import { render, staticRenderFns } from "./DeveloperAgreement.vue?vue&type=template&id=014a4eea&"
import script from "./DeveloperAgreement.vue?vue&type=script&lang=js&"
export * from "./DeveloperAgreement.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperAgreement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports